import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import PersonIcon from '@material-ui/icons/Person';
// import MessageIcon from '@material-ui/icons/Message';
import PhoneIcon from '@material-ui/icons/Phone';
import SmsIcon from '@material-ui/icons/Sms';
import EmailIcon from '@material-ui/icons/Email';
import PeopleOutline from '@material-ui/icons/PeopleOutline';
import DateRange from '@material-ui/icons/DateRange';

const getTableColumns = () => [
  {
    key: 'chapterName',
    label: (
      <Tooltip title='Chapter Name'>
        <PersonIcon />
      </Tooltip>
    ),
    isTooltipAllowed: true,
  },
  // {
  //   key: 'filteredStatuses',
  //   label: (
  //     <Tooltip title='Selected Statuses'>
  //       <MessageIcon />
  //     </Tooltip>
  //   ),
  //   isTooltipAllowed: true,
  // },
  {
    key: 'callsReceived',
    label: (
      <Tooltip title='Calls Received'>
        <PhoneIcon />
      </Tooltip>
    ),
    isTooltipAllowed: true,
  },
  {
    key: 'textsReceived',
    label: (
      <Tooltip title='Texts Received'>
        <SmsIcon />
      </Tooltip>
    ),
    isTooltipAllowed: true,
  },
  {
    key: 'emailsReceived',
    label: (
      <Tooltip title='Emails Received'>
        <EmailIcon />
      </Tooltip>
    ),
    isTooltipAllowed: true,
  },
  {
    key: 'eventsAttended',
    label: (
      <Tooltip title='Events Attended - determined by "Attended Meeting or Activity" milestone'>
        <DateRange />
      </Tooltip>
    ),
    isTooltipAllowed: true,
  },
  {
    key: 'membersInvolved',
    label: (
      <Tooltip title='Members Involved'>
        <PeopleOutline />
      </Tooltip>
    ),
    isTooltipAllowed: true,
  },
];

export default getTableColumns;
